/**
 * Wizard feature module (W2-14 onboarding-wizard; DESIGN.md §4.3, §5.1; WORKPACKAGES Appendix B: `project.new`).
 *
 * Provides:
 *  - `DIALOG.wizard` (modal): the new-chart wizard (WizardDialog.tsx);
 *  - wizard steps `song` (10), `picture` (20), `details` (30) and `start` (50); the Beat step (40) is the timing
 *    package's;
 *  - command `project.new` (Library start card, Project menu, palette): opens the wizard;
 *  - settings row `ext.wizard.charter`: the charter name the wizard pre-fills (saved on Create).
 */

import { DIALOG } from '../../app/dialogs/types';
import type { CommandDef, FeatureModule, SettingDef } from '../../app/registry/types';
import { CHARTER_EXT_KEY } from './draft';
import { m } from './wizard.messages';
import { WizardDialog } from './WizardDialog';
import { WIZARD_STEPS } from './wizardSteps';

const newChart: CommandDef = {
  id: 'project.new',
  title: m.cmdNew,
  category: 'File',
  icon: 'Plus',
  aliases: ['new', 'new chart', 'new project', 'create', 'start from a song', 'wizard', '新建', '新建谱面'],
  level: 'guided',
  menus: [{ menu: 'app.project', group: 'new', order: 10 }],
  async run(ctx) {
    await ctx.ui.openDialog(DIALOG.wizard, {});
  },
};

const SETTINGS: readonly SettingDef[] = [
  {
    path: `ext.${CHARTER_EXT_KEY}`,
    title: m.settingCharter,
    description: m.settingCharterHelp,
    level: 'guided',
    kind: 'string',
  },
];

export default {
  id: 'wizard',
  commands: [newChart],
  dialogs: [{ id: DIALOG.wizard, kind: 'modal', component: WizardDialog }],
  wizardSteps: WIZARD_STEPS,
  settings: SETTINGS,
} satisfies FeatureModule;
